module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__manipulator",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "label": "Тип расчёта",
      "required": true,
      "name": "type",
      "id": "type",
      "data-vv-as": ' ',
      "error": _vm.errors.first('type')
    },
    model: {
      value: (_vm.price.type),
      callback: function($$v) {
        _vm.$set(_vm.price, "type", $$v)
      },
      expression: "price.type"
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Выбрать...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("По весу")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("По объёму")])]), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "col-6",
    attrs: {
      "label": 'Тип расчёта цены по времени',
      "required": true,
      "name": "is_min",
      "id": "is_min",
      "data-vv-as": ' ',
      "error": _vm.errors.first('is_min')
    },
    model: {
      value: (_vm.price.is_min),
      callback: function($$v) {
        _vm.$set(_vm.price, "is_min", $$v)
      },
      expression: "price.is_min"
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Выбрать...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 0
    }
  }, [_vm._v("За 1 час")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("За всё время")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0.000,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{required: true, min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": ("Минимальный " + ((parseInt(_vm.price.type) == 1 ? ' вес' : ' объём'))),
      "name": "value_min",
      "id": "value_min",
      "data-vv-name": "value_min",
      "error": _vm.errors.first('value_min'),
      "type": "number",
      "data-vv-as": ' ',
      "required": ""
    },
    model: {
      value: (_vm.price.value_min),
      callback: function($$v) {
        _vm.$set(_vm.price, "value_min", $$v)
      },
      expression: "price.value_min"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0.000,
        max_value: 9999999999,
        decimal: [3, '.']
      }),
      expression: "{required: true, min_value: 0.000, max_value: 9999999999, decimal: [3, '.']}"
    }],
    staticClass: "col-6",
    attrs: {
      "label": ("Максимальный " + ((parseInt(_vm.price.type) == 1 ? ' вес' : ' объём'))),
      "name": "value_max",
      "id": "value_max",
      "data-vv-name": "value_max",
      "error": _vm.errors.first('value_max'),
      "type": "number",
      "data-vv-as": ' ',
      "required": ""
    },
    model: {
      value: (_vm.price.value_max),
      callback: function($$v) {
        _vm.$set(_vm.price, "value_max", $$v)
      },
      expression: "price.value_max"
    }
  })], 1), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        integer: true,
        min_value: 0,
        max_value: 9999999999
      }),
      expression: "{required: true, integer: true, min_value: 0, max_value: 9999999999}"
    }],
    attrs: {
      "label": "Минимальное время (часы)",
      "name": "min_time",
      "id": "min_time",
      "data-vv-name": "min_time",
      "error": _vm.errors.first('min_time'),
      "type": "number",
      "data-vv-as": ' ',
      "required": ""
    },
    model: {
      value: (_vm.price.min_time),
      callback: function($$v) {
        _vm.$set(_vm.price, "min_time", $$v)
      },
      expression: "price.min_time"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min_value: 0.01,
        max_value: 9999999999,
        decimal: [2, '.']
      }),
      expression: "{required: true, min_value: 0.01, max_value: 9999999999, decimal: [2, '.']}"
    }],
    attrs: {
      "name": "price",
      "id": "price",
      "label": ("Цена за " + ((parseInt(_vm.price.type) == 2 ? ' объём' : ' вес') + (_vm.price.is_min ? ' (за весь)' : ' (за единицу)'))),
      "required": "",
      "error": _vm.errors.first('price'),
      "type": "number",
      "data-vv-name": "price",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.price.price),
      callback: function($$v) {
        _vm.$set(_vm.price, "price", $$v)
      },
      expression: "price.price"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61343e19","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/cost/views/manipulator/Manipulator.vue
// module id = 1165
// module chunks = 0